import { ProjectionFilter } from './projection-filter';

/**
 * Projection configuration for a relation
 */
export class ProjectionRelation {
	/**
	 * Fields to include from this relation
	 * If empty or undefined, all fields are included
	 * Use ['*'] to explicitly include all fields
	 */
	fields?: string[];

	/**
	 * Filters to apply to items in this collection
	 * Only applicable for array relations
	 */
	filters?: ProjectionFilter[];

	/**
	 * Nested projections for relations within this relation
	 * Example: { "files": { "fields": ["uuid", "name"] } }
	 */
	relations?: Record<string, ProjectionRelation>;
}
